import { useTranslation } from 'react-i18next';

import styles from './BoardFilterBar.module.css';

interface Props {
  value: string;
  onChange: (value: string) => void;
}

/** Search field with an always-reachable clear button (iOS has no native one). */
export function SearchBox({ value, onChange }: Props) {
  const { t } = useTranslation();
  return (
    <div className={styles.searchWrap}>
      <input
        type="search"
        className={styles.search}
        value={value}
        placeholder={t('filter.searchPlaceholder')}
        aria-label={t('filter.search')}
        maxLength={200}
        enterKeyHint="search"
        onChange={(e) => {
          onChange(e.target.value);
        }}
      />
      {value !== '' && (
        <button
          type="button"
          className={styles.clearSearch}
          aria-label={t('filter.clearSearch')}
          onClick={() => {
            onChange('');
          }}
        >
          ×
        </button>
      )}
    </div>
  );
}
